import { securityCards } from '@/mocks/homeData';

export default function SecurityTrustSection() {
  return (
    <section id="guvenlik" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-4">
            Verileriniz güvende, işlemleriniz kayıt altında.
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            Profesyonel altyapı ve yetkilendirme sistemi ile operasyon verileriniz güvenle saklanır.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {securityCards.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-6 border border-background-200/70 group flex gap-4"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 flex-shrink-0 flex items-center justify-center bg-foreground-50 rounded-lg">
                <i className={`${item.icon} text-foreground-600 text-lg md:text-xl`}></i>
              </div>
              <div>
                <h3 className="font-heading font-semibold text-base text-foreground-950 mb-1.5">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}